export default __webpack_public_path__ + "static/media/a11y.2565f7a6.png";